export default {
  name: 'Article list section - 4',
  tab: 'article list',
  type: 'category-listing-default-section',
  content: {
    title: 'Article list',
    introtext: '',
    articles:
      '[{"article-title":"Article 1","article-introtext":"<p>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Nullam quis risus eget urna mollis ornare vel eu leo. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper.</p><p>&nbsp;</p><p>Pellentesque ornare sem lacinia quam venenatis vestibulum. Nullam quis risus eget urna mollis ornare vel eu leo. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper.</p>","article-image":"","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 2","article-introtext":"<p>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Nullam quis risus eget urna mollis ornare vel eu leo. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper.</p>","article-image":"","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image':
      '/storage/media/samples/jeremy-thomas-Qw2CUd_9OWo-unsplash.jpg',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '121px',
    'title-color': 'var(--text-light-color)',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h2',
    'introtext-color': 'inherit',
    'article-title-color': 'var(--secondary-color)',
    'article-title-font-weight': 'lighter',
    'article-title-tag': 'h6',
    'article-introtext-color': 'var(--secondary-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'article-columns': '2',
    'content-box': '1',
    'content-box-wrap': 'item',
    'content-box-color': 'var(--background-color)',
    'content-box-padding': '40px',
    'content-box-opacity': '0.92',
    'content-box-elevation': '3',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '1'
  },
  advanced: {}
}
